import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { from, of } from 'rxjs';
import { concatMap, delay, repeat } from 'rxjs/operators';
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
import { takeUntil } from "rxjs/operators";
import { FormBuilder } from "@angular/forms";
import { latLng, tileLayer } from "leaflet";
import { DataService } from "src/app/shared/Services/data.service";
import { HttpClient } from "@angular/common/http";
import { Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthenticationService } from "../../core/services/auth.service";

import { AuthfakeauthenticationService } from "../../core/services/authfake.service";
import { environment } from "src/environments/environment";
// import { ChartType } from "../moreInfo/echart/echart.model";
import { ChartType } from "src/app/pages/moreInfo/echart/echart.model"
@Component({
  selector: 'app-superdashboard',
  templateUrl: './superdashboard.component.html',
  styleUrls: ['./superdashboard.component.scss']
})
export class superdashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  rotationSubscription: Subscription;
  data: any[] = [];
  isLoopPaused: boolean = false;
  currentRotationIndex: number = 0;
  ngOnInit(): void {
    // this.refreshDashboard();


    this.apiInterval = setTimeout(() => {
      if (this.isAlive) {
        // this.toastr.info("Click the Refresh button to get live Data");
      }
    }, 180000);
  }


  startRotation(data: any[], startIndex: number = 0) {
    if (this.rotationSubscription && !this.rotationSubscription.closed) {
      this.rotationSubscription.unsubscribe();
    }

    let currentIndex = startIndex;
    this.rotationSubscription = from(data).pipe(
      concatMap((device, index) => {
        // Track the current index
        currentIndex = index;
        return of(device).pipe(
          delay(index === 0 && startIndex === 0 ? 0 : 15000) // first record immediately on initial start, others after 10s
        );
      }),
      repeat(), // infinite loop
      takeUntil(this.destroy$)
    ).subscribe(record => {
      this.currentRotationIndex = currentIndex;
      console.log('Processing record:', record);
      this.loadMachineData(record);
    });
  }

  pauseLoop() {
    this.isLoopPaused = true;
    // Actually unsubscribe to stop all background processing
    if (this.rotationSubscription && !this.rotationSubscription.closed) {
      this.rotationSubscription.unsubscribe();
    }
    // Clear all intervals to stop marquee updates and other background tasks
    if (this.apiInterval) {
      clearInterval(this.apiInterval);
      clearTimeout(this.apiInterval);
      this.apiInterval = null;
    }
  }

  resumeLoop() {
    this.isLoopPaused = false;
    // Restart rotation from the next index
    const nextIndex = (this.currentRotationIndex + 1) % this.data.length;
    this.startRotation(this.data, nextIndex);
  }

  loadMachineData(record: any) {
    this.currentItem = [0];

    const shift = { shift: record.shiftData };
    const machine = {
      custID: record.custId || '',
      deviceID: record.deviceId || '',
      department: record.departmentName || '',
      customerName: record.customerName || '',
      deviceName: record.deviceName || '',
      deviceType: record.deviceType || '',
      configType: record.partcountType || (record.oee ? "digital" : "analog"),
      timeZone: record.timeZone || '',
    };
    sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
    sessionStorage.setItem("machineInfio", JSON.stringify(machine));

    this.refreshDashboard();
  }
  logout() {
    let deactivate = sessionStorage.getItem("Deactivate");
    if (deactivate == null || deactivate == "true") {
      if (environment.defaultauth === "firebase") {
        this.authService.logout();
      } else {
        this.authFackservice.logout();
      }
      sessionStorage.clear();
      this.router.navigate(["/account/login"]);
    } else {
      this.toastr.error(
        "You are not allowed to navigate away.",
        "Permission Denied"
      );
    }
  }
  refreshDashboard() {
    var user = JSON.parse(sessionStorage.getItem("superUser") || sessionStorage.getItem("currentUser"));
    var machineData = JSON.parse(sessionStorage.getItem("machineInfio"))
    this.custName = user["user"];
    this.timeZone = machineData.timeZone || "Asia/Kolkata"
    // this.timeZone =
    //   user["user"]["timeZone"] ||
    //   sessionStorage.getItem("Selected_CustomerTimeZone");
    this.role = this.custName.role;
    this.userName = sessionStorage.getItem("Selected_CustomerName");
    this.shift_Time = this.custName["currentShift"];
    var shared_data = JSON.parse(sessionStorage.getItem("machineInfio"));
    if (!shared_data) {
      // If no machine selected yet, pick first from data
      this.loadMachineData(this.data[0]);
      return;
    }
    this.params = shared_data;
    var shift = JSON.parse(sessionStorage.getItem("shiftInfio"));
    this.allShift = shift["shift"];
    this.currentShift = this.getcurrentShift.getCurrentShift(
      shift["shift"],
      this.timeZone
    );
    this.selectedCars = this.currentShift["shiftName"];
    this.params.shiftName = this.currentShift?.usershiftId;
    this.deviceName = this.params.deviceName;
    this.deviceType = this.params.deviceType;
    // delete this.params.deviceName;
    this.breadCrumbItems = [
      { label: this.userName ? this.userName : "K2" },
      { label: "Machine_Info", active: true },
    ];
    this.spinner.show();
    this.getCustData(this.params);

    var newparam = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      date: [
        moment(this.currentShift["currentDate"]).format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(2, "days")
          .format("YYYY-MM-DD"),
      ],
    };
    var newparam2 = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      date: [
        moment(this.currentShift["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(2, "days")
          .format("YYYY-MM-DD"),
      ],
    };
    this.getGanttChart(this.params);
    this.getAllEfficiency(newparam);
    this.getHourlyDowntime(newparam);
    this.history_chart(newparam2);
    this.getCyclgapData();
  }




  private cancelPreviousRequests$ = new Subject<void>();
  private isAlive = true;
  @ViewChild("marque") marque!: ElementRef;
  isChecked = false;
  donughnutChart: ChartType;
  private destroy$: Subject<void> = new Subject<void>();
  custName: any;
  shift_Time;
  isCollapsed = true;
  userName: any = "";
  role: any;
  device_bar_chart: any;
  currentStatus: string;
  isReactivePower: boolean = false;
  reactive_power: any;
  trendChart: any = [];
  LUT;
  status;
  m_effic;
  parts;
  combinedData;
  availability;
  quality;
  perf;
  totalPartCount: any = 0;
  pieStatus: any = [];
  t_energy;
  showPieChart: boolean = false;
  finalcombinedData: any = [];
  selectedDateOption: string = "Live";
  historycombinedData: any = [];
  previousDays: any = [];
  typeData: any;
  showChart: boolean = false;
  showChart1: boolean = false;
  pie_response: any;
  clustr_Chart: boolean = false;
  cluster_data: any = [];
  showGantt: boolean = false;
  selectedCars = "All Shift";
  breadCrumbItems: Array<{}>;
  options = {
    layers: [
      tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 18,
        attribution: "...",
      }),
    ],
    zoom: 6,
    center: latLng(46.879966, -121.726909),
  };
  showHourlychart: boolean = true;
  deviceName;
  apiInterval: any;
  currentShift: any;
  allShift = [];
  params: any;
  intervalFlag: boolean = true;
  deviceType;
  prodLoss: any;
  energycost: any;
  showHourchart: boolean = false;
  hourlyData: any;
  trendData: any = "partData";
  outLine: boolean = false;
  timeLine: boolean = true;
  partDetails: boolean = false;
  selectedTab: string = "TimeLines";
  showCombined: boolean = false;
  historydata: boolean = false;
  historyDatas = [];
  currentDay = [];
  yesterDay = [];
  previousyesterDay = [];
  ganttData: any;
  isLineChart: boolean = true;
  timeZone: any;
  totalHourlyPartCount: any;
  operatorName: any;
  partName: any;
  liveBool: boolean = false;
  chartOptions = {};
  barChartOption = {};
  todayStatusData: any = [];
  yesterDayStatusData: any = [];
  daybeforeYesterdayStatusData: any = [];
  currentIndex = 0;
  currentItem: any = [];
  Ai_partcount: any;
  Ai_partcount2: any;
  allData: any = [];
  today: any;
  today2: any;
  proviousDay: any;
  proviousDay2: any;
  marqueItems: any = [];
  isInsite: boolean = true;
  overAllData: any = [];
  showload = false;
  showload2 = false;
  isData = false;
  isRefresh = false;
  machineInfo: any;
  partcountType: any;
  iscycleData: boolean = false;
  custId;
  any;
  cycleData: any = [];
  hourlyDowntimeOption: any = {};
  hourlyData2: any = [];
  hourlyDowntimeChartData: any = [];
  insiteData: any = [];
  cycleChart: any = [];
  deviceList: any = [];
  downtimeDurationsHHMMSS: string[] = ["00:00:00", "00:00:00", "00:00:00"];
  hourlyDowntimeData: any = [];
  cyclegap: any;
  subscriptions: Subscription[] = [];
  barchartShowLoad = true;

  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private getcurrentShift: GetCurrentShift,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
  ) {
    const superUserBackupStr = sessionStorage.getItem('superUser');
    if (superUserBackupStr) {
      const superUser = JSON.parse(superUserBackupStr);
      this.authFackservice.updateCurrentUser(superUser);
      sessionStorage.removeItem('actingAsCustomer');
    }

    var user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custName = user?.["user"] || "";
    var adminCustId = sessionStorage.getItem("Selected_CustomerID");
    this.machineInfo = JSON.parse(sessionStorage.getItem("machineInfio"));
    this.custId = this.custName?.id || "";
    if (this.custId == "customer profile is nor exists for SUPERADMIN user") {
      this.custId = adminCustId;
      this.custDevices(this.custId);
    } else {
      this.custDevices(this.custId);
      // this.auditLogs()
    }
    this.role = this.custName.role;
    this.userName = sessionStorage.getItem("Selected_CustomerName");
    this.shift_Time = this.custName["currentShift"];
  }


  // ngOnInit replaced by refreshDashboard
  auditLogs() {
    let obj = {
      custID: this.custId
    }
    const subscription = this.dataservice
      .reportApi(
        'auditlog/machine',
        obj
      ).subscribe(
        (res) => {

        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );
    this.subscriptions.push(subscription);
  }

  getCyclgapData() {
    let obj = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      startTime: this.currentShift["start"],
      endTime: this.currentShift["end"],
    };
    this.currentDay = [];
    this.dataservice
      .plantApi(
        "handlingTime",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.cycleData = res;
            if (this.cycleData['Handeling_time'].length && this.cycleData['Handeling_insight'].length && this.cycleData['Handeling_Gap'].length) {

              this.iscycleData = true;
            } else {
              this.iscycleData = false;

            }
            if (this.isChecked) {
              this.getcyclegap();
            }
          } else {
            this.iscycleData = false;
          }
        },
        (error) => {
          this.iscycleData = false;
          this.toastr.error(error);
        }
      );
  }
  custDevices(id) {
    this.dataservice
      .get(`api/oemdevices/${id}`)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe((res: any) => {
        console.log(res, "res")
        this.deviceList = res?.['mapedDevices'] || [];
        console.log(this.deviceList, "deviceList")
        this.data = this.deviceList
        this.currentItem = [];
        this.currentIndex = 0;

        this.startRotation(this.data);  // this.deviceList = res.filter(
        //   (element) => this.machineInfo.department == element.departmentName
        // );
      });
  }
  handleDeviceSelection(selectedDeviceName: string) {
    this.pauseLoop();
    this.currentItem = [];
    this.currentIndex = 0;
    this.iscycleData = false;
    this.isChecked = false;
    let data = this.deviceList.filter((val) => {
      if (val.deviceName == selectedDeviceName) {
        return val;
      }
    });
    console.log(data, "data")
    if(data[0].oee === 'no_part'){

      var record: any = {
        // custID: this.custId,
        custID: data[0].custId,
        deviceID: data[0].deviceId,
        department: data[0].departmentName,
        deviceName: data[0].deviceName,
        deviceType: data[0].deviceType,
        configType: data[0].oee,
        customerName: data[0].customerName || '',
        timeZone: data[0].timeZone || '',
      };
      // sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
      sessionStorage.setItem("machineInfio", JSON.stringify(record));
      this.refreshDashboard();
    }else{
      var record: any = {
        // custID: this.custId,
        custID: data[0].custId,
        deviceID: data[0].deviceId,
        department: data[0].departmentName,
        deviceName: data[0].deviceName,
        deviceType: data[0].deviceType,
        configType: data[0].oee,
        customerName: data[0].customerName || '',
        timeZone: data[0].timeZone || '',
         partcountType:data[0]["partcountType"]
      };
      // sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
      sessionStorage.setItem("machineInfio", JSON.stringify(record));
      this.refreshDashboard();
    }
  }

  onDropdownClick() {
    this.pauseLoop();
  }

  refreshCurrentDevice() {
    // Refresh the currently selected device without resuming the loop
    this.cancelPreviousRequests$.next();
    var shift = JSON.parse(sessionStorage.getItem("shiftInfio"));
    this.currentShift = this.getcurrentShift.getCurrentShift(
      shift["shift"],
      this.timeZone
    );
    (this.iscycleData = false), (this.isChecked = false);
    this.isRefresh = true;
    if (this.apiInterval) clearTimeout(this.apiInterval);
    this.liveBool = true;
    this.getCustData(this.params);

    var newparam = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      date: [
        moment(this.currentShift["currentDate"]).format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(2, "days")
          .format("YYYY-MM-DD"),
      ],
    };
    this.getAllEfficiency(newparam);
    this.getHourlyDowntime(newparam);
    var newparam2 = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      date: [
        moment(this.currentShift["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(2, "days")
          .format("YYYY-MM-DD"),
      ],
    };
    this.history_chart(newparam2);
    this.getGanttChart(this.params);
    this.getCyclgapData();
  }

  refreshData() {
    this.cancelPreviousRequests$.next();
    var shift = JSON.parse(sessionStorage.getItem("shiftInfio"));
    this.currentShift = this.getcurrentShift.getCurrentShift(
      shift["shift"],
      this.timeZone
    );
    (this.iscycleData = false), (this.isChecked = false);
    this.isRefresh = true;
    if (this.apiInterval) clearTimeout(this.apiInterval);
    this.liveBool = true;
    this.getCustData(this.params);
    // this.getPartCount(this.params);

    var newparam = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      date: [
        moment(this.currentShift["currentDate"]).format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(2, "days")
          .format("YYYY-MM-DD"),
      ],
    };
    this.getAllEfficiency(newparam);
    this.getHourlyDowntime(newparam);
    var newparam2 = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      date: [
        moment(this.currentShift["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
        moment(this.currentShift["currentDate"])
          .subtract(2, "days")
          .format("YYYY-MM-DD"),
      ],
    };
    this.history_chart(newparam2);
    this.getGanttChart(this.params);
    this.getCyclgapData();
  }

  getGanttChart(params: any) {
    let obj = {
      custID: params["custID"],
      deviceID: params["deviceID"],
    };
    this.currentDay = [];
    this.dataservice
      .machineApi(
        "ganttChart",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res["overall_status"].length) {
            this.showChart = true;
            this.currentDay = res["overall_status"];
            this.todayStatusData = res["chart_data"];
          } else {
            this.currentDay = [];
            this.showChart = false;
          }
        },
        (error) => {
          this.showChart = false;
          this.toastr.error(error);
        }
      );
  }
  isPartTwo: boolean = false
  getAllEfficiency(params: any) {
    this.showload = true;
    this.showload2 = true;
    this.dataservice
      .plantApi("hourlypartcount",
        params
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.isData = true;
            this.showload2 = false;
            this.overAllData = res["data"];
            this.hourlyData = this.overAllData[0]["partcountDetails"];
            if (this.overAllData?.[0]?.hasOwnProperty('pin2_count')) {
              this.isPartTwo = true;
            } else {
              console.log("else");

              this.isPartTwo = false;
            }
            if (this.isRefresh == false) {
              this.today2 = `Today - ${moment(
                this.currentShift["currentDate"]
              ).format("YYYY-MM-DD")} - (Efficiency ${res["data"][0]["efficiency"] ? res["data"][0]["efficiency"] : 0
                } %)`;
            }
            this.proviousDay = `Yesterday  - ${moment(
              this.currentShift["currentDate"]
            )
              .subtract(1, "day")
              .format("YYYY-MM-DD")}  - (Efficiency ${res["data"][1]["efficiency"] ? res["data"][1]["efficiency"] : 0
              } %)`;
            this.proviousDay2 = `Day Before Yesterday - ${moment(
              this.currentShift["currentDate"]
            )
              .subtract(2, "days")
              .format("YYYY-MM-DD")} - (Efficiency ${res["data"][2]["efficiency"] ? res["data"][2]["efficiency"] : 0
              }%)`;
          } else {
            this.isData = false;
            this.showload2 = false;
            this.today2 = `Today`;
            this.proviousDay = `Yesterday`;
            this.proviousDay2 = `Day Before Yesterday`;
          }
        },
        (error) => {
          this.showload2 = false;
          this.isData = false;
          this.toastr.error(error);
        }
      );
  }

  getHourlyDowntime(params: any) {
    this.dataservice
      .plantApi(
        'machine_downtimeReasons',
        params
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.hourlyDowntimeData = res["data"];
            this.downtimeDurationsHHMMSS = this.hourlyDowntimeData
              .slice(0, 3)
              .map((item) =>
                this.convertMinutesToHHMMSS(item?.downtimeDuration || 0)
              );
          } else {
          }
        },
        (error) => {
          this.toastr.error(error);
        }
      );
  }
  convertMinutesToHHMMSS(minutes: number): string {
    const totalSeconds = Math.floor(minutes * 60);
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  getCustData(param: any) {
    if (param.shiftName) {
    } else {
      this.params.shiftName = this.currentShift?.usershiftId;
    }
    if (!this.liveBool) {
      this.dataservice
        .machineApi(
          "machineCard",
          param
        )
        .pipe(takeUntil(this.cancelPreviousRequests$))
        .subscribe(
          (res: any) => {
            this.allData = res;
            this.t_energy = res["total_energy"] || 0;
            // this.Ai_partcount = res["Ai_partcount"] || 0;
            this.LUT = res["LUT"] || moment().startOf("hour").valueOf();
            this.m_effic = res["oee"] ? res["oee"].toFixed(1) : 0;
            this.partcountType = res["partcountType"];
            this.operatorName = res["operatorName"] ? res["operatorName"] : "";
            this.partName = res["partName"] ? res["partName"] : "";
            this.status = res["status"];

            var anomalyparams = {
              custID: this.params["custID"],
              deviceID: this.params["deviceID"],
              startTime: this.currentShift["start"],
              endTime: this.currentShift["end"],
            };
            this.anomalysummary(anomalyparams);
            // if (this.isRefresh == true) {
            //   this.today2 = `Today - (Efficiency ${this.m_effic ? this.m_effic : 0
            //     } %)`;
            // }
          },
          (error) => {
            this.toastr.error(error);
          }
        );
    } else {
      this.dataservice
        .machineApi(
          "liveMachine",
          param
        )
        .pipe(takeUntil(this.cancelPreviousRequests$))
        .subscribe(
          (res: any) => {
            this.allData = res;
            if (this.isPartTwo) {
              this.Ai_partcount = res["pin1_count"] || 0;
              this.Ai_partcount2 = res["pin2_count"] || 0;
            } else {
              this.Ai_partcount = res["pin1_count"] || 0;
            }
            this.t_energy = res["total_energy"] || 0;
            this.LUT = res["LUT"] || moment().startOf("hour").valueOf();
            this.m_effic = res["oee"] ? res["oee"].toFixed(1) : 0;
            this.partcountType = res["partcountType"];
            this.operatorName = res["operatorName"] ? res["operatorName"] : "";
            this.partName = res["partName"] ? res["partName"] : "";
            this.status = res["status"];

            var anomalyparams = {
              custID: this.params["custID"],
              deviceID: this.params["deviceID"],
              startTime: this.currentShift["start"],
              endTime: this.currentShift["end"],
            };
            this.anomalysummary(anomalyparams);
            this.today2 = `Today - ${moment(
              this.currentShift["currentDate"]
            ).format("YYYY-MM-DD")} - (Efficiency ${this.m_effic ? this.m_effic : 0
              } %)`;
          },
          (error) => {
            this.toastr.error(error);
          }
        );
    }
  }


  anomalysummary(params: any) {
    this.dataservice
      .plantApi(
        "anomalySummary",
        params
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            if (this.apiInterval) clearTimeout(this.apiInterval)
            this.currentItem = [];
            this.currentIndex = 0;
            this.isInsite = false;
            this.showload = false;
            this.showHourlychart = true;
            this.insiteData = res["anomaliesData_Summary"];
            // this.cycleChart = res["anomaliesCycles_Chart"];
            // if (this.cycleChart.lenght != 0) {
            //   this.anomalyBarChart();
            // }
            if (this.insiteData.length != 0) {
              console.log(this.insiteData);
              this.currentItem = this.insiteData[this.currentIndex];
              console.log(this.currentItem);
              this.isInsite = true;
              this.showload = false;
              this.apiInterval = setInterval(() => {
                this.currentIndex =
                  (this.currentIndex + 1) % this.insiteData.length;
                this.currentItem = this.insiteData[this.currentIndex];
              }, 10000);
            } else {
              console.log(this.insiteData, this.currentIndex, this.currentItem, "else");
              if (this.apiInterval) clearTimeout(this.apiInterval)
              this.currentItem = [];
              this.currentIndex = 0;
              this.isInsite = false;
              this.showload = false;
              // if (this.allData.length) {
              this.marqueItems = [
                `The total energy consumption is ${this.allData?.total_energy ? this.allData?.total_energy : 0
                } kWh, representing the total electrical energy used over a given period.`,
                `The total current consumed is ${this.allData?.total_current ? this.allData?.total_current : 0
                } Amperes (A), indicating the flow of electric charge through the system.`,
                `The real power is ${this.allData?.real_power ? this.allData?.real_power : 0
                } Watts (W), which represents the actual power utilized for performing work.`,
                `The apparent power is ${this.allData?.apparent_power ? this.allData?.apparent_power : 0
                } Volt-Amperes (VA), signifying the product of voltage and current in the system.`,
                `The availability rate is ${this.allData?.availability ? this.allData?.availability : 0
                }%, reflecting the proportion of time the system is operational and ready for use.`,
                `The performance efficiency is ${this.allData?.performance ? this.allData?.performance : 0
                }%, representing the effectiveness of the system in utilizing resources for optimal output.`,
                `The quality index is ${this.allData?.quality ? this.allData?.quality : 0
                }%, measuring the adherence to predefined standards and accuracy in operations.`,
                `The overall machine efficiency is ${this.allData?.oee ? this.allData?.oee : 0
                }%, indicating how effectively energy is converted into useful work.`,
                `The power unit cost is ${this.allData?.powerUnitCost ? this.allData?.powerUnitCost : 0
                }, representing the cost associated with consuming one unit of power.`,
              ];
              // this.marqueItems=[{`The total energy consumption is ${this.allData?.total_energy ? this.allData?.total_energy : 0
              // } kWh, representing the total electrical energy used over a given period.`}]


              this.currentItem = this.marqueItems[this.currentIndex];
              // this.currentItem = 'no Data'
              console.log(this.currentItem, this.marqueItems, "else");

              this.isInsite = true;
              this.showload = false;
              this.apiInterval = setInterval(() => {
                this.currentIndex =
                  (this.currentIndex + 1) % this.marqueItems.length;
                this.currentItem = this.marqueItems[this.currentIndex];
              }, 10000);
              console.log(this.currentItem, "else");

              // }
            }
            this.spinner.hide();
          } else {
            this.showHourlychart = false;
            this.spinner.hide();
            this.showload = false;
          }
        },
        (error) => {
          this.spinner.hide();
          this.isInsite = false;
          this.showload = false;
          this.toastr.error(error);
        }
      );
  }

  // getPartCount(param: any) {
  //   if (param.shiftName) {
  //   } else {
  //     this.params.shiftName = this.currentShift.usershiftId;
  //   }
  //   this.dataservice.partCount(param).subscribe(
  //     (res) => {
  //       this.parts =
  //         res["partcount_Type"] == "AI" ? res["pattern_count"] : this.count;
  //       this.typeData = res["partcount_Type"];
  //     },
  //     (error) => {
  //       this.toastr.error(error);
  //     }
  //   );
  // }

  ngOnDestroy() {
    this.isAlive = false;
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    if (this.apiInterval) {
      clearTimeout(this.apiInterval);
    }
    if (this.marque) {
      const el = this.marque.nativeElement as HTMLElement;
      el.style.animation = "none"; // Stops the animation immediately
    }
    this.toastr.clear();
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCurrentShift(shifts: any) {
    const currentTime = new Date();
    const currentTimeString = `${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}`;
    const statuses = [];
    for (const shift of shifts) {
      if (
        this.compareTimes(currentTimeString, shift.startTime) >= 0 &&
        this.compareTimes(currentTimeString, shift.endTime) <= 0
      ) {
        statuses.push({
          shiftName: shift.shiftName,
          status: "Running",
        });
      } else if (this.compareTimes(currentTimeString, shift.startTime) < 0) {
        statuses.push({
          shiftName: shift.shiftName,
          status: "Upcoming",
        });
      } else {
        statuses.push({
          shiftName: shift.shiftName,
          status: "Past",
        });
      }
    }
    return statuses;
  }

  compareTimes(time1: any, time2: any) {
    const [hours1, minutes1, seconds1] = time1.split(":").map(Number);
    const [hours2, minutes2, seconds2] = time2.split(":").map(Number);

    if (hours1 !== hours2) {
      return hours1 - hours2;
    } else if (minutes1 !== minutes2) {
      return minutes1 - minutes2;
    } else {
      return seconds1 - seconds2;
    }
  }

  getSecondsFromString(timeString: any) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  epochToHHMMSS(epochTime: any) {
    return moment.tz(epochTime, this.timeZone).format("YYYY-MM-DD HH:mm:ss");
  }

  secondsToHms(data: any) {
    data = Number(data);
    if (Math.sign(data) == -1) {
      data = Math.abs(data);
    }
    const hours = Math.floor(data / 60);
    const minutes = Math.floor(data % 60);
    const seconds = Math.round((data * 60) % 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }

  houers(data: any) {
    let valueInHMS = "00:00:00";
    if (this.pie_response) {
      let existing = this.pie_response.find((item) => item.name == data);
      if (existing == undefined) {
        valueInHMS = "00:00:00";
      } else {
        valueInHMS = this.secondsToHms(existing.value);
      }
    }
    return valueInHMS;
  }

  backbtn(data: any) {
    if (this.role === "CUSTOMER") this.router.navigate(["/liveDashboard"]);
    else if (this.role === "SUPERADMIN") this.router.navigate(["/admin"]);
    else if (this.role === "SUPERVISOR") this.router.navigate(["/"]);
  }

  statusColor(data: any) {
    switch (data) {
      case 1: {
        this.currentStatus = "Running";
        return "#548237";
        break;
      }
      case 0: {
        this.currentStatus = "Idle";
        return "#f7c030";
        break;
      }
      case 2: {
        this.currentStatus = "Breakdown";
        return "#eb5857";
        break;
      }
      case 3: {
        this.currentStatus = "Interlock";
        return "#7B542F";
        break;
      }
      case 4: {
        this.currentStatus = "Off";
        return "#b0b0b0";
        break;
      }
    }
  }
  history_chart(param: any) {
    this.barchartShowLoad = true;
    this.showChart1 = false;
    this.historydata = false;
    // this.currentDay = [];
    this.yesterDay = [];
    this.previousyesterDay = [];
    this.dataservice
      .machineApi("ganttChart_lastDays", param)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.showChart1 = true;
            this.historydata = true;
            this.barchartShowLoad = false;
            this.yesterDay = res["overall_status1"];
            this.previousyesterDay = res["overall_status2"];
            // this.previousyesterDay = res["overall_status3"];
            this.yesterDayStatusData = res["chart_data1"];
            this.daybeforeYesterdayStatusData = res["chart_data2"];
            // this.daybeforeYesterdayStatusData = res["chart_data3"];
          } else {
            this.showChart1 = false;
            this.yesterDay = [];
            this.previousyesterDay = [];
            this.barchartShowLoad = false;
          }
        },
        (error) => {
          this.showChart1 = false;
          this.barchartShowLoad = false;
          this.toastr.error(error);
        }
      );
  }

  getTitle(data: any) {
    return data
      ? data.charAt(0).toUpperCase() + data.slice(1).toLowerCase()
      : "";
  }

  openModal(content: any, chartType: string) {
    if (chartType === "currentDay") {
      if (this.todayStatusData.length) {
        const outputData = this.todayStatusData.map((item) => {
          var color;
          if (item.status === "dryrun") {
            color = "#ffff94";
          } else if (item.status === "running") {
            color = "#548237";
          } else if (item.status === "idle") {
            color = "#f7c030";
          } else if (item.status === "breakdown") {
            color = "#eb5857";
          } else if (item.status === "interlock") {
            color = "#7B542F";
          } else if (item.status === "off") {
            color = "#b0b0b0";
          } else if (item.status === "warning") {
            color = "#bfe0a5";
          } else if (item.status === "alarm") {
            color = "#ee4932";
          }
          return {
            value:
              Math.sign(item.duration) == -1
                ? Math.abs(item.duration)
                : item.duration,
            name: item.status,
            percent: item.percent,
            itemStyle: {
              color: color,
            },
          };
        });
        this.showPieChart = true;
        this.pie_response = outputData;
      }
      this.loadDonutChart(this.pie_response, "Today's");
    } else if (chartType === "yesterDay") {
      if (this.yesterDayStatusData.length) {
        const outputData = this.yesterDayStatusData.map((item) => {
          var color;
          if (item.status === "dryrun") {
            color = "#ffff94";
          } else if (item.status === "running") {
            color = "#548237";
          } else if (item.status === "idle") {
            color = "#f7c030";
          } else if (item.status === "breakdown") {
            color = "#eb5857";
          } else if (item.status === "interlock") {
            color = "#7B542F";
          } else if (item.status === "off") {
            color = "#b0b0b0";
          } else if (item.status === "warning") {
            color = "#bfe0a5";
          } else if (item.status === "alarm") {
            color = "#ee4932";
          }
          return {
            value:
              Math.sign(item.duration) == -1
                ? Math.abs(item.duration)
                : item.duration,
            name: item.status,
            percent: item.percent,
            itemStyle: {
              color: color,
            },
          };
        });
        this.showPieChart = true;
        this.pie_response = outputData;
      }
      this.loadDonutChart(this.pie_response, "Yesterday's");
    } else if (chartType === "previousyesterDay") {
      if (this.daybeforeYesterdayStatusData.length) {
        const outputData = this.daybeforeYesterdayStatusData.map((item) => {
          var color;
          if (item.status === "dryrun") {
            color = "#ffff94";
          } else if (item.status === "running") {
            color = "#548237";
          } else if (item.status === "idle") {
            color = "#f7c030";
          } else if (item.status === "breakdown") {
            color = "#eb5857";
          } else if (item.status === "interlock") {
            color = "#7B542F";
          } else if (item.status === "off") {
            color = "#b0b0b0";
          } else if (item.status === "warning") {
            color = "#bfe0a5";
          } else if (item.status === "alarm") {
            color = "#ee4932";
          }
          return {
            value:
              Math.sign(item.duration) == -1
                ? Math.abs(item.duration)
                : item.duration,
            name: item.status,
            percent: item.percent,
            itemStyle: {
              color: color,
            },
          };
        });
        this.showPieChart = true;
        this.pie_response = outputData;
      }
      this.loadDonutChart(this.pie_response, "DaybeforeYesterday's");
    }
    this.modalService.open(content, {
      backdrop: "static",
      centered: true,
      size: "md",
    });
  }
  loadDonutChart(data: any, day: any) {
    this.chartOptions = {
      title: {
        text: `${day} Status Chart`,
        left: "center",
        textStyle: {
          color: "#000",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          var value = params.value;
          var hours = Math.floor(value / 60);
          var minutes = Math.floor(value % 60);
          var seconds = Math.floor((value * 60) % 60);
          var formattedValue =
            hours.toString().padStart(2, "0") +
            ":" +
            minutes.toString().padStart(2, "0") +
            ":" +
            seconds.toString().padStart(2, "0");

          return `${params.seriesName}<br/>${params.name}: ${formattedValue} (${params.percent}%)`;
        },
      },
      legend: {
        bottom: "5%",
        left: "center",
      },
      series: [
        {
          name: "Status",
          type: "pie",
          radius: ["40%", "60%"],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          label: {
            normal: {
              show: false,
              position: "center",
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            formatter: function (params) { },
          },
          // itemStyle: {
          //   borderRadius: 5,
          //   borderColor: "rgba(0, 0, 0, 0.5)",
          //   borderWidth: 1,
          // },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: data,
        },
      ],
    };
  }
  ngAfterViewInit(): void { }

  anomalyBarChart() {
    this.barChartOption = {
      title: {
        text: "Hourly Anomaly",
        left: "center",
        top: -5,
        textStyle: {
          fontSize: 14,
          color: "#28a745",
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "item",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        borderColor: "#fff",
        borderWidth: 1,
        textStyle: {
          color: "#fff",
          fontSize: 12,
          fontFamily: "Arial",
        },
        formatter: function (params) {
          const data = params.data || {};

          return `
            <b>Time:</b> ${params.name || data.time || "N/A"} <br/>
            <b>Anomaly:</b> ${params.value || "N/A"}<br/>
            <b>Start Hour:</b> ${data.Starthour || "N/A"} <br/>
            <b>End Hour:</b> ${data.Endhour || "N/A"} <br/>
             <b>Current:</b> ${data.current || "N/A"} Amp <br/>
            <b>Duration:</b> ${data.Duration || "N/A"}
          `;
        },
      },
      grid: {
        left: "1%",
        right: "1%",
        top: "25%",
        bottom: "50",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: this.cycleChart.map((item) => item.time),
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}",
        },
        splitLine: {
          show: false,
        },
      },
      color: "#08bdba",
      series: [
        {
          name: "Highest",
          type: "bar",
          data: this.cycleChart.map((item) => ({
            value: item.value,
            name: item.time,
            Starthour: item.Starthour,
            Endhour: item.Endhour,
            Duration: item.Duration,
            current: item.current,
          })),
          markPoint: {
            symbolSize: 40,
            data: this.cycleChart,
          },
        },
      ],
    };
  }

  openModal2(infotemplate: any, parameter: any, day: any) {
    this.modalService.dismissAll();
    this.trendChart = [];
    this.trendData = parameter;
    if (this.trendData === "partData") {
      this.showHourchart = true;
      if (day === "currentDay") {
        this.hourlyData2 = this.overAllData[0]["partcountDetails"];
      } else if (day === "yesterDay") {
        this.hourlyData2 = this.overAllData[1]["partcountDetails"];
      } else if (day === "previousyesterDay") {
        this.hourlyData2 = this.overAllData[2]["partcountDetails"];
      }
      if (this.hourlyData2.lenght == 0) {
        this.showHourchart = false;
      }

      setTimeout(() => {
        this.modalService.dismissAll();

        this.modalService.open(infotemplate, {
          backdrop: "static",
          centered: true,
          size: "xl",
        });
      }, 1000);
    } else if (parameter === "downtimedata") {
      if (day === "currentDay") {
        this.hourlyDowntimeChartData =
          this.hourlyDowntimeData[0]["downtimeData"];
      } else if (day === "yesterDay") {
        this.hourlyDowntimeChartData =
          this.hourlyDowntimeData[1]["downtimeData"];
      } else if (day === "previousyesterDay") {
        this.hourlyDowntimeChartData =
          this.hourlyDowntimeData[2]["downtimeData"];
      }
      this.getDowntimeChart();
      this.modalService.open(infotemplate, {
        backdrop: "static",
        centered: true,
        size: "xl",
      });
    }
  }
  onChartClick(event) {
    console.log("Clicked Bar Data:", event?.data?.name || event?.data?.time);
  }
  onSwitchChange(event) {
    this.isChecked = event;
    if (this.isChecked) {
      this.getcyclegap();
    }
  }
  getcyclegap() {
    this.cyclegap = {
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: {
          color: "#333",
          fontSize: 12,
        },
        formatter: function (params) {
          const point = params[0];
          const time = point.axisValue;

          // Your value is inside point.data.value
          const gap = point.data?.value ?? "N/A";

          return `
      <b>Time:</b> ${time} <br/>
      <b>Duration:</b> ${gap} Sec
    `;
        },
      },
      toolbox: {
        show: true,
        feature: {
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Reset Zoom",
            },
          },

          restore: {
            title: "Restore Original",
          },
        },
      },

      dataZoom: [
        {
          type: "inside",
          xAxisIndex: 0,
          start: 99,
          end: 100,
        },
      ],
      title: {
        left: "center",
        text: "Handling time",
        textStyle: {
          color: "green",
          fontStyle: "normal",
          fontWeight: "normal",
          fontSize: 14,
        },
      },
      xAxis: {
        name: "(hrs)",
        type: "category",
        boundaryGap: true,
        splitLine: {
          show: false,
        },
        data: this.cycleData["Handeling_time"],
      },
      yAxis: {
        type: "value",
        name: "(sec)",
        nameLocation: "middle",
        nameGap: 40,
        splitLine: {
          show: false,
        },
        splitNumber: 5,
      },
      grid: {
        top: "10%",
        left: "5%",
        right: "5%",
        bottom: 70,
        containLabel: true,
      },
      series: [
        {
          name: "Duration (sec)",
          type: "bar",
          data: this.cycleData["Handeling_Gap"],
        },
      ],
    };
  }

  getDowntimeChart() {
    if (this.hourlyDowntimeChartData.length === 0) {
      this.hourlyDowntimeOption = {
        title: {
          text: "No Data",
          left: "center",
          top: "middle",
          textStyle: {
            fontSize: 18,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    const reasonsSet = new Set<string>();

    this.hourlyDowntimeChartData.forEach((hourObj: any) => {
      hourObj.reasons.forEach((item: any) => reasonsSet.add(item.reason));
    });

    const reasons = Array.from(reasonsSet);

    // Header
    const header: string[] = ["Hour", ...reasons];
    const source: (string | number)[][] = [header];

    // Fill rows
    this.hourlyDowntimeChartData.forEach((hourObj: any) => {
      const row: (string | number)[] = [hourObj.hour];
      reasons.forEach((reason) => {
        const found = hourObj.reasons.find((r: any) => r.reason === reason);
        row.push(found ? found.duration : 0);
      });
      source.push(row);
    });

    // Dynamic series
    const series = reasons.map((reason) => ({
      type: "bar",
      stack: "total",
      name: reason,
      encode: { x: "Hour", y: reason },
    }));

    // Chart option
    this.hourlyDowntimeOption = {
      toolbox: {
        show: true,
        feature: {
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom",
              back: "Reset",
            },
          },

          restore: {
            title: "Restore",
          },
        },
      },

      dataZoom: [
        {
          type: "inside",
          xAxisIndex: 0,
          start: 0,
          end: 100,
        },
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: {
          color: "#333",
        },
        formatter: function (params) {
          let tooltipText = `<strong>${params[0].axisValue}</strong><br/>`;

          // Find the longest series name for alignment
          const maxNameLength = Math.max(
            ...params.map((p) => p.seriesName.length)
          );

          let hasDowntime = false;

          params.forEach((item) => {
            const totalMinutes = item.data[item.encode.y[0]];
            if (totalMinutes > 0) {
              hasDowntime = true;
              const totalSeconds = Math.round(totalMinutes * 60);

              const hours = Math.floor(totalSeconds / 3600);
              const minutes = Math.floor((totalSeconds % 3600) / 60);
              const seconds = totalSeconds % 60;

              const formatted = [
                hours.toString().padStart(2, "0"),
                minutes.toString().padStart(2, "0"),
                seconds.toString().padStart(2, "0"),
              ].join(":");

              tooltipText += `
        ${item.marker}
        <span style="display:inline-block; width:${maxNameLength}ch; text-align:left;">
          ${item.seriesName}
        </span>
        : ${formatted}<br/>
      `;
            }
          });

          if (!hasDowntime) {
            tooltipText += `<b>No Downtime</b>`;
          }

          return tooltipText;
        },
      },
      xAxis: {
        type: "category",
        name: "Hours",
        nameLocation: "middle",
        nameGap: 30,
        axisLabel: {
          formatter: function (value) {
            // Assuming value format is "HH:MM-HH:MM"
            const parts = value.split("-");
            return parts[1] || value; // return end hour
          },
        },
      },
      yAxis: {
        type: "value",
        name: "Downtime (minutes)",
        nameLocation: "middle",
        nameRotate: 90,
        nameGap: 50,
      },
      dataset: { source },
      series,
    };
  }


}
